/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import './ProfileTitle.scss';
import EditIcon from '../../../../svgs/EditIcon';
import MinimizeIcon from '../../../../svgs/MinimizeIcon';
import AddIcon from '../../../../svgs/AddIcon';

interface IProfileTitle {
  name?: string;
  onClick?: () => void;
  index?: number;
  hasViewOnlyTab?: boolean;
  }

const ProfileTitle = ({
  name, onClick, index, hasViewOnlyTab,
}: IProfileTitle) => {
  const history = useHistory();
  const [showSubProfile, setShowSubProfile] = useState(false);
  const [showProfileEditPage, setShowProfileEditPage] = useState(false);
  const { customerId } = useParams<{ customerId: string }>();
  const [isViewOnly, setIsViewOnly] = useState(false);

  const handleAddIconClick = () => {
    setShowSubProfile(!showSubProfile);
  };

  useEffect(() => {
    setIsViewOnly(name === 'Selfie' || hasViewOnlyTab === true);
  }, []);

  const handleProfileUpdate = () => {
    setShowProfileEditPage(!showProfileEditPage);

    switch (name) {
    case 'Student Details':
    case 'Personal Details':
      history.push(`/customers/customer-details/${customerId}/student-details`);
      break;
    case 'Residential Details':
      history.push(`/customers/customer-details/${customerId}/residential-details`);
      break;
    case 'Institution Details':
      history.push(`/customers/customer-details/${customerId}/institution-details`);
      break;
    case 'Account Verification':
      history.push(`/customers/customer-details/${customerId}/documents`);
      break;
    default:
      break;
    }
  };

  return (
    <div className="profile-title-cover">
      <div className="profile-name-and-index">
        <span className={`profile-index ${showSubProfile ? 'profile-index-active' : 'profile-index-inactive'}`}>
          {`${index < 10 ? '0' : ''}${index}`}
          {' '}
        </span>
        <div className="profile-title-name">{name}</div>
      </div>

      <div>
        {showSubProfile ? (
          <div className="edit-profile-and-detail-cover">
            {!isViewOnly && (
            <div
              className="profile-edit-icon"
              onClick={handleProfileUpdate}
            >
              <EditIcon width="13.3px" height="13.3px" />
            </div>
            )}

            <div
              className="profile-minimize-icon"
              onClick={() => {
                onClick();
                setShowSubProfile(false);
              }}
            >
              <MinimizeIcon />
            </div>
          </div>
        ) : (
          <div
            className="profile-add-icon"
            onClick={() => {
              onClick();
              handleAddIconClick();
            }}
          >
            <AddIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileTitle;
